import React from 'react';
import { Dropdown, Layout } from 'antd';
import { Link } from 'react-router';
import logo from '../assets/logo.png';

import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';

const { Header } = Layout;

export const RelyantHeader = ({
  isAuthenticated,
  user,
  isCollapsed,
  setIsCollapsed,
  dropdDownItems,
  withLogo = false,
}: {
  isAuthenticated;
  user;
  isCollapsed: boolean;
  setIsCollapsed: (state: boolean) => void;
  dropdDownItems;
  withLogo?: boolean;
}) => {
  return (
    <Header style={{ background: '#fff', padding: 0 }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ paddingLeft: 16 }}>
          {isCollapsed ? (
            <MenuUnfoldOutlined className="trigger" onClick={() => setIsCollapsed(!isCollapsed)} />
          ) : (
            <MenuFoldOutlined className="trigger" onClick={() => setIsCollapsed(!isCollapsed)} />
          )}
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center' }}>
          {withLogo && (
            <div
              style={{
                paddingLeft: 16,
              }}
            >
              <Link to="/">
                <img width={'50%'} src={logo} alt="Logo" />
              </Link>
            </div>
          )}
        </div>

        {isAuthenticated && (
          <div style={{ paddingRight: 16 }}>
            <Dropdown menu={{ items: dropdDownItems }}>
              <img src={user?.picture} alt="Profile" className="nav-user-profile rounded-circle" width={'50'} />
            </Dropdown>
          </div>
        )}
      </div>
    </Header>
  );
};
